'use strict';

import * as dom from './lib/dom.js';

function openCardModal(e) {
    const target = e.target;
    console.log(target);
    if (target.tagName.toLowerCase() === 'a' || dom.hasClass(target, 'js-modal-run')) { return }
    e.preventDefault();
    const parentEl = dom.parents(target, 'js-open-card-modal');
    const modalId = parentEl.getAttribute('data-id');
    const modal = document.querySelector('.js-card-modal[data-id="' + modalId + '"]');
    const bodyEl = document.querySelector('body');
    console.log(modalId);
    dom.addClass(modal, 'o-modal-card--active');
    bodyEl.style.overflow = 'hidden';


};

function closeCardModal(e) {
    const target = e.target;
    const modal = dom.parents(target, 'js-card-modal');
    const bodyEl = document.querySelector('body');
    dom.removeClass(modal, 'o-modal-card--active');
    bodyEl.style.overflow = '';
};

export default function() {
    const modalOpenTriggers = document.querySelectorAll('.js-open-card-modal');
    dom.forEachEl(modalOpenTriggers, (el) => {
        el.addEventListener('click', openCardModal);
    });

    const modalCloseTriggers = document.querySelectorAll('.js-close-card-modal');
    dom.forEachEl(modalCloseTriggers, (el) => {
        el.addEventListener('click', closeCardModal);
    });
};
